var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.194708 0.774402C0.319542 0.649724 0.488759 0.579694 0.665191 0.579694C0.841622 0.579694 1.01084 0.649724 1.13567 0.774402L5.9914 5.63013L10.8471 0.774402C10.9081 0.708991 10.9816 0.656525 11.0633 0.620136C11.1449 0.583748 11.2331 0.564181 11.3225 0.562604C11.4119 0.561026 11.5007 0.577471 11.5836 0.610956C11.6665 0.644441 11.7418 0.694281 11.805 0.757502C11.8682 0.820723 11.9181 0.89603 11.9515 0.978931C11.985 1.06183 12.0015 1.15063 11.9999 1.24002C11.9983 1.32942 11.9788 1.41758 11.9424 1.49925C11.906 1.58091 11.8535 1.65442 11.7881 1.71537L6.46189 7.04158C6.33705 7.16626 6.16784 7.23629 5.9914 7.23629C5.81497 7.23629 5.64576 7.16626 5.52092 7.04158L0.194708 1.71537C0.0700303 1.59053 0 1.42132 0 1.24488C0 1.06845 0.0700303 0.899236 0.194708 0.774402Z",
    fill: "#201E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.3c5fe4b49044f6cd3fb7583f10f8f842.svg";
export { ForwardRef as ReactComponent };